import type { ComponentPropsWithoutRef } from 'react';
import styled from 'styled-components';
import type { HighlightedVideoMediaItem } from 'components/GalleryMediaPreviewer/shared/types';
import Image from 'components/generic/Image';
import dynamic from 'helpers/dynamic';
import { MediaCarouselItem } from '../../GalleryThumbnailCarousel';

const StyledThumbnailImg = styled(Image.WithScaling)`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

const PlayIcon = styled(dynamic(() => import('icons/Play.svg?react'), { ssr: false }))`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const ThumbnailHighlightedVideoItem = ({
    highlightedVideoItem: { thumbnail },
    isActive,
    ...restProps
}: {
    highlightedVideoItem: HighlightedVideoMediaItem;
    isActive: boolean;
} & ComponentPropsWithoutRef<'button'>) => (
    <MediaCarouselItem $isActive={isActive} {...restProps}>
        <PlayIcon width={32} height={32} />
        <StyledThumbnailImg alt="" sizes={94} src={thumbnail} transformType="ThumbnailScale" imageType="product" />
    </MediaCarouselItem>
);

export default ThumbnailHighlightedVideoItem;
